export type RenderVerticalAlign = 'top' | 'center' | 'bottom';

export const DEFAULT_VERTICAL_ALIGN: RenderVerticalAlign = 'top';

/** The one place an absent `verticalAlign` becomes a value; TS and Rust agree on it via render-rule.json. */
export function resolveVerticalAlign(v: RenderVerticalAlign | undefined | null): RenderVerticalAlign {
  return v ?? DEFAULT_VERTICAL_ALIGN;
}
